module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('address', [_c('p', [_c('b', [_vm._v("Privatbrauerei Zissel")]), _c('br'), _vm._v("\n                Im Grund 15"), _c('br'), _vm._v("\n                92341 Kulmbach"), _c('br'), _vm._v("\n                Inhaber: Peter Gröger"), _c('br'), _vm._v("\n                Telefon: (0 92 14) 13 24 53"), _c('br'), _vm._v("\n                Fax: (0 92 14) 13 24 55"), _c('br'), _vm._v("\n                E-Mail: "), _c('a', {
    attrs: {
      "href": "mailto:peter.groeger@zisselbier.de"
    }
  }, [_vm._v("peter.groeger@zisselbier.de")])])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Aufgabenstellung:")]), _c('br'), _vm._v("\n            Zentral-Fachausschuss"), _c('br'), _vm._v("\n            Berufsbildung Druck und Medien"), _c('br'), _vm._v("\n            Wilhelmshöher Allee 260"), _c('br'), _vm._v("\n            34131 Kassel\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-010db7cf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/partials/footer.vue
// module id = 27
// module chunks = 0